// extracted by mini-css-extract-plugin
export var banner = "hero-module--banner--04227";
export var content = "hero-module--content--c3fef";
export var detailPill = "hero-module--detail-pill--ba77b";
export var detailPillBooked = "hero-module--detail-pill--booked--f026f";
export var detailPillCancelled = "hero-module--detail-pill--cancelled--c6343";
export var detailPillRescheduled = "hero-module--detail-pill--rescheduled--448f2";
export var details = "hero-module--details--13ec0";
export var headline = "hero-module--headline--f7756";
export var hero = "hero-module--hero--d526b";
export var image = "hero-module--image--da78c";
export var title = "hero-module--title--f0e14";